import { IHeadLabel, ISort } from "../types/table";

const userOrderOptions: ISort[] = [
    {
        label: "Nome Crescente",
        direction: "asc",
        sortBy: "Name"
    },
    {
        label: "Nome Decrescente",
        direction: "desc",
        sortBy: "Name"
    },
    {
        label: "Cadastro Crescente",
        direction: 'asc',
        sortBy: 'Id'
    },
    {
        label: "Cadastro Decrescente",
        direction: 'desc',
        sortBy: 'Id'
    }
];

const columnsTable: IHeadLabel[] = [
    {
        label: "ID",
    },
    {
        label: "Nome"
    },
    {
        label: "Username"
    },
    {
        label: "Ativo"
    },
    {
        label: "",
        align: "right"
    }
];

const tabsUpdate = [
    {
        value: 'data',
        label: 'Dados',
        icon: 'solar:user-id-bold'
    },
    {
        value: 'password',
        label: 'Senha',
        icon: 'ic:round-vpn-key',        
    },
    {
        value: 'systems',
        label: 'Sistemas',
        icon: 'tdesign:system-code'
    }
];

const columnsTableUpdateSystem: IHeadLabel[] = [
    {
        label: "",
        width: 150,
    },
    {
        label: "Filial",
    },
    {
        label: "Sistema"
    },   
];

export {
    userOrderOptions,
    columnsTable,
    tabsUpdate,
    columnsTableUpdateSystem
}